import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
} from "react";
import Loader from "../../components/Loader";
import { useNavigate } from "react-router-dom";
import useList from "../../controller/list-controller";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import { toast } from "react-toastify";
import { debounce } from "debounce";
import { buildColumns } from "../../utils/helper";
import TableContainer from "../../components/table/TableContainer";
import Offer from "../../assets/sidebar/dealerPortal/Offer";
import { ConstListContext } from "../../context/constListContext";

export default function Schemesorders() {
  const navigate = useNavigate();
  const prevStateRef = useRef();
  const constContData = useContext(ConstListContext);
  const { isLoader: isLoading2, constData } = constContData;
  const { getListViewRecords, tableData, isLoading, errMsg } = useList();
  const [isLoader, setIsLoader] = useState(false);
  const [search, setSearch] = useState();
  const [sortOptions, setSortOptions] = useState([]);
  const [sort, setSort] = useState("");
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [currPage, setCurrPage] = useState(0);
  const [totalRec, setTotalRec] = useState(0);
  const [flag, setFlag] = useState(true);
  const [orderCol, setOrderCol] = useState("");
  const [orderType, setOrderType] = useState("");

  useEffect(() => {
    setFlag(false);
  }, []);

  useEffect(() => {
    setIsLoader(isLoading || isLoading2);
  }, [isLoading, isLoading2]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  useEffect(() => {
    if (constData?.["Scheme Order"]?.length > 0) {
      const otpData = constData?.["Scheme Order"]?.map((dt) => ({
        label: dt.listViewName,
        value: dt.listViewId,
      }));

      const actFil = constData?.["Scheme Order"]?.find((dt) => dt?.isDefault);
      setSort(actFil?.listViewId);
      setSortOptions([...otpData]);
    }
  }, [constData]);

  useEffect(() => {
    const header = buildColumns(tableData?.fields);

    setColumns(header);
    setData(tableData?.records);
    (tableData?.totalRecordCount || tableData?.totalRecordCount === 0) &&
      setTotalRec(
        tableData?.totalRecordCount
          ? parseInt(tableData?.totalRecordCount) / tableData?.recordCount
          : 1
      );
  }, [tableData]);

  useEffect(() => {
    prevStateRef.current !== sort && setSearch("");
    if (sort) {
      if (orderCol || orderType) {
        setOrderCol("");
        setOrderType("");
      }
      if (!flag) getList(search, sort);
    }
    prevStateRef.current = sort;
  }, [sort]);

  const getList = (searchData = search, sortData = sort) => {
    getListViewRecords({
      objectName: "Scheme Order",
      listViewId: sortData,
      pageNo: 1,
      orderByField: "",
      orderByAPIField: "",
      orderDirection: "",
      searchKey: searchData,
    });
  };

  const getSearchDebounce = useCallback(
    debounce((searchData, sortData) => {
      getListViewRecords({
        objectName: "Scheme Order",
        listViewId: sortData,
        pageNo: 1,
        orderByField: "",
        orderByAPIField: "",
        orderDirection: "",
        searchKey: searchData,
      });
    }, 500),
    []
  );

  const handleGetSchemes = (page = 0, field = "", apiField = "", dir = "") => {
    let pageNo = page + 1;
    setCurrPage(page);
    getListViewRecords({
      objectName: "Scheme Order",
      listViewId: sort,
      pageNo: pageNo,
      orderByField: field,
      orderByAPIField: apiField,
      orderDirection: dir,
      searchKey: search,
    });
  };

  const handleRowClick = (row) => {
    navigate(`/schemes-orders/${row?.original?.orderId}`);
  };

  const handleSearch = (val) => {
    if (orderCol || orderType) {
      setOrderCol("");
      setOrderType("");
    }
    setSearch(val);
    getSearchDebounce(val, sort);
  };

  return (
    <div
      className={`flex flex-col md:mt-0 md:pt-0 overflow-hidden ${
        isLoader && !data ? "h-full mt-[0px]" : "h-full pt-[70px]"
      } `}
    >
      {isLoader && !data ? (
        <Loader />
      ) : data?.length > 0 || columns?.length > 0 ? (
        <>
          <PageHeader
            svg={<Offer color="white" width="24" height="24" />}
            text="Schemes / Orders"
            subTitle={
              tableData?.recordCount && tableData?.totalRecordCount
                ? `${
                    tableData?.recordCount && tableData?.pageNo
                      ? tableData?.recordCount * (tableData?.pageNo - 1) <= 0
                        ? 1
                        : tableData?.recordCount * (tableData?.pageNo - 1) + 1
                      : 0
                  } to ${tableData?.recordCount * tableData?.pageNo || 0} of ${
                    tableData?.totalRecordCount || 0
                  } Items`
                : "0 to 0 of 0 Items"
            }
            isFilter={true}
            isSearch={true}
            search={search}
            setSearch={handleSearch}
            options={sortOptions}
            sort={sort}
            setSort={setSort}
            onSearchChange={handleSearch}
          />
          {columns && (
            <TableContainer
              data={data}
              columns={columns?.filter((col) => {
                return col?.fieldLabel;
              })}
              rowClick={handleRowClick}
              gotoPage={handleGetSchemes}
              pageIndex={currPage}
              isLoading={isLoader}
              pageCount={totalRec}
              orderCol={orderCol}
              setOrderCol={setOrderCol}
              orderType={orderType}
              setOrderType={setOrderType}
              fullHeight={true}
            />
          )}
        </>
      ) : null}
    </div>
  );
}
